import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../shared/modals/modal.component';

type ConfirmBalancesClearModalProps = {
  isVisible: boolean,
  hideModal: () => void,
  clearBsmBalances: () => void,
  isLoadingClearBsmBalances: boolean,
}

const ConfirmBalancesClearModal: React.FC<ConfirmBalancesClearModalProps> = ({
  isVisible,
  hideModal,
  clearBsmBalances,
  isLoadingClearBsmBalances,
}) => (
  <Modal
    title="Confirm deletion"
    dismissText="Cancel"
    submitText="Delete"
    closeAction={hideModal}
    dismissAction={hideModal}
    isSubmitting={isLoadingClearBsmBalances}
    submitAction={clearBsmBalances}
    isVisible={isVisible}
  >
    Are you sure you want to remove Balance Sheet Management balances for the selected company codes in all periods?
  </Modal>
);


ConfirmBalancesClearModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired,
  clearBsmBalances: PropTypes.func.isRequired,
  isLoadingClearBsmBalances: PropTypes.bool.isRequired,
};

export default ConfirmBalancesClearModal;

